<template>
  <div class="tab">
    <el-footer v-if="showManageFooter" class="tab__footer page__active_bar">
      <el-button
        v-if="$can('update', 'intercoms')"
        class="page__active_button"
        id="submit"
        type="primary"
        @click="submit"
      >
        Сохранить
      </el-button>
      <el-button
        v-if="$can('delete', 'intercoms')"
        class="page__active_button"
        id="delete"
        type="danger"
        @click="removeIntercom"
      >
        Удалить
      </el-button>
    </el-footer>
    <main class="page_container">
      <el-form class="page__form" :model="form" ref="form" :rules="rules" label-position="right" label-width="240px">
        <el-form-item label="Название" prop="short_name">
          <el-input id="short_name" size="small" v-model="form.short_name" :readonly="!$can('update', 'intercoms')" />
        </el-form-item>
        <el-form-item label="Адрес" prop="address">
          <el-input id="address" size="small" v-model="form.address" :readonly="!$can('update', 'intercoms')" />
        </el-form-item>
        <el-form-item label="UUID" prop="uuid">
          <el-input id="uuid" size="small" v-model="form.uuid" :readonly="!$can('update', 'intercoms')"/>
        </el-form-item>
        <el-form-item label="Начало диапазона квартир" prop="apartment_from">
          <el-input id="apartment_from" size="small" v-model="form.apartment_from" :readonly="!$can('update', 'intercoms')"/>
        </el-form-item>
        <el-form-item label="Конец диапазона квартир" prop="apartment_to">
          <el-input id="apartment_to" size="small" v-model="form.apartment_to" :readonly="!$can('update', 'intercoms')"/>
        </el-form-item>
        <el-form-item label="Смещение диапазона квартир" prop="apartment_offset">
          <el-input id="apartment_offset" size="small" v-model="form.apartment_offset" />
        </el-form-item>
        <el-form-item label="SIP-сервер" prop="id_sip_server">
          <select-sip-server
            v-model="form.id_sip_server"
            @change="(id_sip_server) => (form.id_sip_server = id_sip_server)"
            @clear="() => (form.id_sip_server = null)"
          />
        </el-form-item>
      </el-form>
    </main>
  </div>
</template>

<script>
import {
  length,
  required,
  validatorNumber,
} from "@/core/helpers/validators";
import { mapActions, mapState } from "vuex";
import SelectSipServer from '@/components/SipServers/components/feature/SelectSipServer';

export default {
  name: "IntercomEditTab",
  components: {
    SelectSipServer,
  },
  data() {
    return {
      form: {
        short_name: "",
        address: "",
        uuid: "",
        apartment_from: "",
        apartment_to: "",
        apartment_offset: "",
        id_sip_server: null,
      },
      rules: this.$can("update", "intercoms")
        ? {
            short_name: [required(), length(2, 100)],
            address: [required(), length(2, 200)],
            uuid: [length(4, 100)],
            apartment_from: [required(),  validatorNumber, length(1, 10)],
            apartment_to: [required(), validatorNumber, length(1, 10)],
            apartment_offset: [required(), validatorNumber, length(1, 10)],
          }
        : null,
    };
  },
  computed: {
    ...mapState("intercom", ["intercom"]),
    showManageFooter() {
      return this.$can("update", "intercoms") || this.$can("delete", "intercoms");
    },
  },
  watch: {
    intercom(intercom) {
      this.form = Object.assign({}, intercom);
    },
  },
  methods: {
    ...mapActions("intercom", {
      save: "UPDATE_INTERCOM",
      deleteIntercom: "DELETE_INTERCOM",
    }),
    submit() {
      this.$refs["form"].validate((valid) => {
        if (valid) {
          this.save({
            id: this.intercom.id_intercom,
            data: {
              short_name: this.form.short_name,
              address: this.form.address,
              uuid: this.form.uuid,
              apartment_from: this.form.apartment_from,
              apartment_to: this.form.apartment_to,
              apartment_offset: this.form.apartment_offset,
              id_sip_server: this.form.id_sip_server,
            },
          })
            .then(() => {
              this.$message({
                message: "Информация обновлена",
                type: "success",
              });
            })
            .catch(() => {
              this.$message({
                message: `При редактировании домофона произошла ошибка`,
                type: "error",
              });
            })
            .finally(() => {
              this.hiddenFields = DEFAULT_HIDDEN_FIELDS;
            });
        }
        return valid;
      });
    },
    removeIntercom() {
      this.$confirm("Вы точно хотите удалить домофон?", "Удаление", {
        confirmButtonText: "Удалить",
        cancelButtonText: "Отмена",
        type: "warning",
      }).then(() => {
        this.deleteIntercom(this.intercom.id_intercom).then(() => {
          this.$message({
            message: "Домофон удален",
            type: "success",
          });
          window.history.back();
        });
      });
    },
  },
};
</script>
